<template>
  <div :class="[{ halloweenmode: isHalloween }]">
    <halloween v-if="isHalloween" />
    <div :class="['grid-container', { nigtmode: isNight }]">
      <div class="box">
        <b-container>
          <b-row>
            <b-col class="mt-3">
              <h3>{{ gantActive ? "Gant" : "Worklogs" }}</h3>
            </b-col>
          </b-row>
          <b-row>
            <b-col v-show="gantActive">
              <AllGant :withVacations="true" />
            </b-col>
            <b-col v-show="!gantActive">
              <Worklogs />
            </b-col>
          </b-row>
        </b-container>
      </div>
      <div class="box url-clock-box">
        <div class="url-clock-block">
          <div class="url">
            <span>ME.APPLYIT.LV</span>
          </div>
          <div class="clock-bg"></div>
          <div class="clock-bg"></div>
          <div class="clock">
            <span>{{ timeA }}</span>
            <span class="secs">{{ timeB }}</span>
          </div>
        </div>
        <b-col align-self="end">
          <h3>Project issue size quality</h3>
          <ProjectIssueForTimeStats />
        </b-col>
      </div>
      <div class="box">
        <Billable />
      </div>
      <div class="box p-4">
        <b-row>
          <b-col cols="3" class="employee-stats">
            <WorkLogStats :sync="60" />
          </b-col>
          <b-col cols="5" class="employee-stats">
            <Absences :days="25" />
          </b-col>
          <b-col cols="4" class="employee-stats">
            <Idle />
          </b-col>
          <!-- <b-col cols="7">
        </b-col> -->
        </b-row>
      </div>
    </div>

  </div>
  <!-- </div> -->
</template>

<script>
import moment from 'moment';
import halloween from '@/views/components/misc/halloween.vue';
import AllGant from '@/views/components/dash/AllProjectGant.vue';
import Billable from '@/views/components/dash/Billable.vue';
import Worklogs from '@/views/components/dash/AllProjectWorklogs.vue';
import WorkLogStats from '@/views/components/dash/WorkLogStats';
import Absences from '@/views/components/dash/Absences';
import Idle from '@/views/components/dash/Idle';
import ProjectIssueForTimeStats from '@/views/components/dash/ProjectIssueForTimeStats';

export default {
  mounted() {
    this.polling = setInterval(() => {
      this.ts = +new Date();
    }, 10);
    this.graphSwitch = setInterval(this.switchViews, 20000);
  },
  beforeDestroy() {
    if (this.polling) {
      clearInterval(this.polling);
    }
    if (this.graphSwitch) {
      clearInterval(this.graphSwitch);
    }
  },
  props: {
  },
  data() {
    return {
      ts: +new Date(),
      polling: null,
      gantActive: true,
    };
  },
  components: {
    AllGant,
    Billable,
    Worklogs,
    WorkLogStats,
    ProjectIssueForTimeStats,
    Absences,
    Idle,
    halloween,
  },
  computed: {
    tsSecs() {
      return Math.round(this.ts / 1000);
    },
    timeFormated() {
      return moment(this.tsSecs * 1000).format('HH:mm:ss');
    },
    timeA() {
      return moment(this.tsSecs * 1000).format('HH:mm');
    },
    timeB() {
      return moment(this.tsSecs * 1000).format(':ss');
    },
    isNight() {
      const h = moment(this.tsSecs * 1000).hour();
      return h < 9 || h > 17;
    },
    curHour() {
      return moment(this.tsSecs * 1000).hour();
    },
    isHalloween() {
      const s = this.tsSecs;
      const d = moment(s * 1000).format('MM-DD');
      return d === '10-31';
    }
  },
  watch: {

  },
  methods: {
    switchViews() {
      this.gantActive = !this.gantActive;
    }
  }
};
</script>

<style lang="scss">
@import url(//fonts.googleapis.com/css?family=Rubik+Distressed);

.halloweenmode div.grid-container {
  background-color: rgba(0, 0, 0, 0);

  .card,
  .card-body,
  .list-group-item,
  .badge.percent-badge {
    background-color: rgba(0, 0, 0, 0);
  }

  path {
    fill: rgba(0, 0, 0, 0);
    stroke-opacity: 0.5;
  }

  rect {
    fill: rgba(0, 0, 0, 0);
    stroke: rgba(1, 1, 1, 0.7);
    stroke-opacity: 0.5;
  }

  text {
    fill: rgba(255, 255, 255, 0.3);
  }
}

div.grid-container {
  background-color: black;
  color: $gray;

  .card-body,
  .list-group-item,
  .badge.percent-badge {
    background-color: black;
  }

  .day-bubble {
    background-color: black;

    &.absence,
    &.idle {
      background-color: #007bff;
    }

    &.weekend {
      background-color: #2d0000;
    }

    &.absence,
    &.idle,
    &.absence.weekend,
    &.idle.weekend {
      background-color: #007bff;
    }

  }
}

.url-clock-box {
  position: relative;

  .url-clock-block {
    // border: solid 1px #00f;
    position: absolute;
    right: 0;
    top: 0;
    z-index: 1;
    width: 100%;
    height: 120px;
    display: flex;
    justify-content: space-around;
    align-items: center;


    .clock-bg {
      background-color: #000;
      filter: blur(1.5rem);
      position: absolute;
      right: 0;
      top: 0;
      left: 0;
      bottom: 0;
    }
  }

  .clock {
    z-index: 2;
    // text-shadow: 0px 0px 5px #fff, 0px 0px 10px #fff, 0px 0px 40px #fff, 0px 0px 40px #fff;

    font-size: 6em;
    font-family: 'Rubik Distressed', sans-serif;
    font-variant-numeric: tabular-nums;
    color: $white;

    .secs {
      font-size: 0.7em;
      color: $gray;
    }
  }

  .url {
    text-align: center;
    z-index: 2;
    font-size: 3em;
    font-family: 'Rubik Distressed', sans-serif;
    color: $white;
  }
}

.employee-stats,
.absences {
  zoom: 80%;
}

.nigtmode .box {
  display: none !important;
}

div.grid-container.nigtmode {
  cursor: none;
}

body {
  height: 100%;
}

body {
  margin: 0;
}

.grid-container {
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  position: absolute;

  // background-color: #fff;
  display: grid;
  grid-template-columns: 50% 50%;
  grid-row: auto auto;
  grid-column-gap: 10px;
  grid-row-gap: 10px;
  overflow: hidden;

  .box {
    display: flex;
    align-items: stretch;
    justify-content: center;

    max-height: 50vh;
    overflow: hidden;

    .card {
      margin: 0;
      border: none;
    }

    &>div {

      flex: 1;

      .vars-chart {
        display: none;
      }

      .card-header {
        display: none;
      }

      .card-body {
        // flex: 1;
        margin: 0;
        padding: 0;
      }

      .chart-body {
        height: calc(50vh - 20px);

        &.with-heading {
          height: calc(50vh - 50px);
        }
      }

    }
  }
}
</style>
